import React from "react";
import PremiumProof from "../PremiumProof";

export default function ProofBlock({ id, type, ...content }) {
  return <PremiumProof content={content} />;
}
